import React, { FC } from "react";

import { Stack, Typography } from "@mui/material";
import { Link } from "gatsby-theme-material-ui";
import { Colors } from "@src/gatsby-theme-material-ui-top-layout/colors";

interface LinkProps {
  label: string;
  path: string;
}

interface Props {
  links: Array<LinkProps>;
}

const SubNav: FC<Props> = ({ links }) => {
  const currentPath = location.pathname;

  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      direction={{ xs: "column", md: "row" }}
      mt="40px"
      spacing={1}
    >
      {links.map((link: LinkProps, idx) => {
        const key = `sub-link-${idx}`;

        if (link.path === currentPath) {
          return (
            <Stack
              key={key}
              sx={{
                padding: "4px 16px 15px",
                borderBottomStyle: "solid",
                borderBottomWidth: "2px",
                borderBottomColor: Colors.PrimaryMain,
              }}
            >
              <Typography
                variant="subtitle1"
                sx={{ color: Colors.PrimaryMain }}
              >
                {link.label}
              </Typography>
            </Stack>
          );
        } else {
          return (
            <Link
              key={key}
              underline="none"
              to={link.path}
              sx={{
                color: Colors.TextSecondary,
                padding: "4px 16px 16px",
                cursor: "pointer",
              }}
            >
              {link.label}
            </Link>
          );
        }
      })}
    </Stack>
  );
};

export default SubNav;
